var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-question-wrap" },
    [
      _c("QrCode", {
        ref: "qrCode",
        on: { getUpdateImg: _vm.getUpdateImg, closeQr: _vm.closeQr },
      }),
      _c(
        "div",
        { staticClass: "subject" },
        [
          !_vm.isHideName
            ? _c("div", { staticClass: "stem" }, [
                _c("div", { staticClass: "nameText" }, [
                  _vm.$route.path === "/practiceAnalysis"
                    ? _c(
                        "em",
                        { class: `${_vm.toggleClass(_vm.datas.topicStatus)}` },
                        [_vm._v(_vm._s(_vm.datas.sort))]
                      )
                    : _c("em", [_vm._v(_vm._s(_vm.datas.sort))]),
                  _c("p", { staticStyle: { flex: "1" } }, [
                    _c("span", [
                      _vm._v("[" + _vm._s(_vm.datas.question_title) + "]"),
                    ]),
                    _c("i", { staticClass: "mal10" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#343434 !important",
                            "white-space": "pre-wrap",
                          },
                        },
                        [_vm._v(_vm._s(_vm.datas.title))]
                      ),
                      _vm._v(" (本题" + _vm._s(_vm.datas.fraction) + "分) "),
                    ]),
                    _vm.datas.title_thumb
                      ? _c("i", [_vm._v("(点击图片放大)")])
                      : _vm._e(),
                  ]),
                ]),
                _vm.isAnalysis
                  ? _c(
                      "div",
                      {
                        staticClass: "operation",
                        on: { click: _vm.showAnalysis },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "uni-cursor",
                            class: { active: _vm.isAnalysis },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont iconhuabanfuben",
                            }),
                            _c("span", [_vm._v("查看解析")]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.datas.audio_url
            ? _c(
                "div",
                { staticClass: "audioDiv" },
                _vm._l(
                  _vm.datas.audio_url.split(","),
                  function (itemAudio, indexAudio) {
                    return _c(
                      "audio",
                      {
                        key: indexAudio,
                        staticClass: "sourceAudio",
                        attrs: { controls: "controls" },
                      },
                      [
                        _c("source", {
                          attrs: { src: itemAudio, type: "audio/ogg" },
                        }),
                        _vm._v(
                          " Your browser does not support the audio element. "
                        ),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _vm.datas.title_thumb
            ? _c("el-image", {
                staticClass: "mat20 mal20",
                staticStyle: { "max-width": "200px", color: "#fff" },
                attrs: {
                  fit: "contain",
                  src: _vm.datas.title_thumb,
                  "preview-src-list": [_vm.datas.title_thumb],
                },
              })
            : _vm._e(),
          _c(
            "el-form",
            { staticClass: "mat20", attrs: { "label-width": "80px" } },
            _vm._l(
              JSON.parse(_vm.datas.fill_in_the_blank),
              function (item, index) {
                return _c(
                  "el-form-item",
                  { key: index, attrs: { label: `填空：` } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        type: "textarea",
                        rows: 1,
                        readonly: _vm.isDisabled,
                      },
                      on: { blur: _vm.theRadio },
                      model: {
                        value: _vm.answer[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.answer, index, $$v)
                        },
                        expression: "answer[index]",
                      },
                    }),
                  ],
                  1
                )
              }
            ),
            1
          ),
          _c("div", { staticClass: "blanksDiv" }, [
            _c("p", [_vm._v("上传图片")]),
            _c("div", { staticClass: "update" }, [
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _vm._l(
                    _vm.datas.choice_correct_thumb,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "updateImgDiv",
                          class: { updateImgDivActive: _vm.isDisabled },
                          staticStyle: { "margin-bottom": "5px" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-close detIcon",
                            on: {
                              click: function ($event) {
                                return _vm.setDelete(index)
                              },
                            },
                          }),
                          _c("el-image", {
                            staticClass: "updateImg",
                            attrs: { fit: "cover", src: item },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "updateImgDiv",
                      class: { updateImgDivActive: _vm.isDisabled },
                      on: { click: _vm.openQrCode },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }